var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ods-container",class:{ 'is-vertical': _vm.isVertical },attrs:{"data-name":"OdsContainer"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }